import { useModelLoader } from '@spazious/dollhouse-engine';
import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import {
  useCollider,
  useDecorationResolver,
  useLayers,
  useOverridedNodeProps,
} from '../../hooks/index.js';
import { DecorationNode } from '../../types/index.js';

export type DecorationProps = Omit<
  GraphNodeProps<DecorationNode>,
  'name' | 'url' | 'decorationType' | 'object' | 'collider' | 'collisions' | 'outline2D'
>;

export const Decoration: React.FC<DecorationProps> = (props) => {
  const layers = useLayers();
  const overridedProps = useOverridedNodeProps(props);

  const { id, ...restProps } = overridedProps;
  const { url, name, decorationType } = useDecorationResolver(id);
  const { scene } = useModelLoader(url);

  const { setRef, collider, collisions, posY } = useCollider(scene, true);

  return (
    <decoration
      ref={setRef}
      id={id}
      {...restProps}
      collider={collider}
      collisions={collisions}
      decorationType={decorationType}
      name={name}
      object={scene}
      positionY={posY ? posY : restProps.positionY}
      url={url}
      visible={props.visible !== false && layers.isEnabled(FShallowNodeTypesEnum.Decoration)}
    />
  );
};
